export default "__VITE_ASSET__mBvLOYYe__"